export const homeAboutContent = {
  smallTitle: "About Us",
  mainTitle: "A farming family from Punjab",
  aboutText:
    "We're a family with generations of farming behind us. Our turmeric is grown on our own fields, then processed and packed in small batches, and every batch is lab-tested before it goes on sale. Kulwant Singh and Inderjit Singh Chahal run the farm and oversee every batch.",
  buttonText: "Our story",
  buttonLink: "about",
};
